<div class="container-fluid" style="font-size: 14px;">
  <div class="d-flex flex-row justify-content-between align-items-center mb-3">
    <h2 class="title" *ngIf="isSupplierForm">{{isEdit ? 'Edit Supplier' : 'Add new Supplier'}}</h2>
    <h2 class="title" *ngIf="!isSupplierForm">{{isEdit ? 'Edit Fiberglass Processing Method' : 'Add new Fiberglass Processing Method'}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="submit()">Save
    </div>
  </div>
  <div [formGroup]="supplierForm">
    <div class="row m-0">
        <div *ngIf="isSupplierForm" class="col-6">
            <div class="row">
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Supplier GSL <span style="color: red;">*</span>
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="supplierGsl" name="supplierGsl" matInput>
                            <mat-error>{{supplierForm.controls.supplierGsl.errors?.message}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Supplier Name <span style="color: red;">*</span>
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="supplierName" name="supplierName" matInput>
                            <mat-error>{{supplierForm.controls.supplierName.errors?.message}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Parent Supplier
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="parentSupplier" name="parentSupplier" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Scx ID
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="scxId" name="scxId" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">SRM
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <mat-select formControlName="srm" name="srm">
                                <mat-option value="true">Yes</mat-option>
                                <mat-option value="false">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="isSupplierForm" class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Destruction <span style="color: red;">*</span>
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <mat-select formControlName="destruction" name="destruction">
                                <mat-option value="true">Yes</mat-option>
                                <mat-option value="false">No</mat-option>
                            </mat-select>
                            <mat-error>{{supplierForm.controls.destruction.errors?.message}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="isSupplierForm ? 'col-6' : 'col-12'">
            <div *ngIf="isSupplierForm" class="row">
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Recycling <span style="color: red;">*</span>
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <mat-select formControlName="recycling" name="recycling">
                                <mat-option value="true">Yes</mat-option>
                                <mat-option value="false">No</mat-option>
                            </mat-select>
                            <mat-error>{{supplierForm.controls.recycling.errors?.message}}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 1
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute1" name="attribute1" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 2
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute2" name="attribute2" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 3
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute3" name="attribute3" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 4
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute4" name="attribute4" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 5
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute5" name="attribute5" matInput>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div *ngIf="!isSupplierForm" class="row">
                <div class="col-xl-6 col-md-6 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Fiberglass Processing Method <span style="color: red;">*</span></div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="processingMethod" name="processingMethod" matInput>
                            <mat-error>{{supplierForm.controls.processingMethod.errors?.message}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Attribute 1
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute1" name="attribute1" matInput>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Attribute 2
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute2" name="attribute2" matInput>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12 p-0">
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 3
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute3" name="attribute3" matInput>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 4
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute4" name="attribute4" matInput>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Attribute 5
                    </div>
                    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
                        <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                            <input formControlName="attribute5" name="attribute5" matInput>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>